import React from "react";
import { tr } from "../../i18n";

const CategoryBadge = ({ category }) => {
  let badgeClass = "";
  let badgeText = "";

  switch (category) {
    case "Attendance":
      badgeClass = "bg-success";
      badgeText = tr("shared:category_attendance");
      break;
    case "LWP":
      badgeClass = "bg-info";
      badgeText = "LWP";
      break;
    case "LWOP":
      badgeClass = "bg-danger";
      badgeText = "LWOP";
      break;
    case "SL":
      badgeClass = "bg-light text-dark";
      badgeText = "SL";
      break;
    case "Overtime":
      badgeClass = "bg-warning text-dark";
      badgeText = tr("shared:category_overtime");
      break;
    default:
      badgeClass = "bg-secondary";
      badgeText = tr("shared:unknown");
  }

  return <span className={`badge ${badgeClass}`}>{badgeText}</span>;
};

export default CategoryBadge;
